<template>
  <div>

    <Loader cover v-if="isProcessing"/>

    <card-subject-info :classSectionId="$route.params.classSectionId" currentPage="STUDENT_STAT"></card-subject-info>

    <vx-card>

      <vs-table-mod :data="studentEnrollDetails"
                    :max-items="tableConfig.maxItemsPerPage"
                    pagination
                    search
      >
        <template slot="header-left">
          <div class="vx-col md:w-1/6 sm:w-full">
            <vs-button v-if="studentEnrollDetails && studentEnrollDetails.length > 0"
                       @click="handlerExportExcelClick"
                       color="primary" icon="icon-download" icon-pack="feather">
              {{ $t('general.excel') }}
            </vs-button>
          </div>
        </template>

        <template slot="header">
          <vx-tooltip :text="$t('general.back')">
            <vs-button
              @click="onBackClick"
              class="ml-2" color="success" icon="icon-arrow-left" icon-pack="feather" radius
              type="filled"></vs-button>
          </vx-tooltip>
        </template>

        <template slot="thead">
          <vs-th v-for="(thead) in table.header" :key="thead.id"
                 :sort-key="thead.id"
                 :width="thead.width">
            {{ $t(thead.title) }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="{ data: tr, index: indextr }"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              {{ tr.student.code }}
            </vs-td>
            <vs-td>
              <div class="flex items-center text-break">
                <vs-avatar :src="getAvatarUrl(tr.student.picturePath)" class="flex-shrink-0 mr-2"
                           size="30px"
                />
                <div>
                  <p>{{ tr.student.firstNameLocal + ' '+ tr.student.lastNameLocal}}</p>
                  <p>{{ tr.student.telephone}}</p>
                </div>
              </div>
            </vs-td>
            <vs-td>
              {{ tr.studentAssignmentQty }}/{{ classAssignments.length }}
            </vs-td>
            <vs-td>
              {{ formatSecondToHHMMSS(tr.totalLearnTime) }}
            </vs-td>
            <vs-td>
              {{ formatSecondToHHMMSS(tr.totalVdoLength) }}
            </vs-td>
            <vs-td>
              {{ tr.totalLearnPercent }}
            </vs-td>

            <template slot="expand">
              <vs-table-mod :data="tr.expandData" max-items="100" >

                <template slot="thead">
                  <vs-th v-for="(thead) in expandTable.header" :key="thead.id"
                         :sort-key="thead.id"
                         :width="thead.width">
                    {{ $t(thead.title) }}
                  </vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr
                    :data="{ data: tr, index: indextr }"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>
                      {{ tr.seq }}
                    </vs-td>
                    <vs-td>
                      {{ formatSecondToHHMMSS(tr.totalLearnTime) }}
                    </vs-td>
                    <vs-td>
                      {{ formatSecondToHHMMSS(tr.totalVdoLength) }}
                    </vs-td>
                    <vs-td>
                      {{ tr.learnPercent }}
                    </vs-td>
                    <vs-td>
                      {{ tr.pretestScore }}/{{ tr.pretestMaxScore }}
                    </vs-td>
                    <vs-td>
                      {{ tr.posttestScore }}/{{ tr.posttestMaxScore }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table-mod>



            </template>

          </vs-tr>
        </template>
      </vs-table-mod>

    </vx-card>

  </div>
</template>

<script>
  import store from '@/store';
  import { APIServerPrisma2 } from "@/constants/config";
  import {tableConfig} from '@/utils/table'
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format';
  import CardSubjectInfo from "@/components/shared/card/CardSubjectInfo";

  import StudentEnrollDetail from '@/store/modules/student-enroll-detail/index';
  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import ClassAssignment from '@/store/modules/courses/class-assignment/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import {getAvatarUrl} from "@/utils/upload";
  import { formatSecondToHHMMSS } from "@/utils/format";

  if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);
  if (!store.state.CourseOutline) store.state.registerModule(`CourseOutline`, CourseOutline);
  if (!store.state.ClassAssignment) store.state.registerModule(`ClassAssignment`, ClassAssignment);

  const {
    mapActions: mapStudentEnrollDetailActions,
  } = createNamespacedHelpers(`StudentEnrollDetail`);
  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);
  const {
    mapActions: mapClassAssignmentActions,
  } = createNamespacedHelpers(`ClassAssignment`);


  const {
    mapFields: mapStudentEnrollDetailFields,
  } = createHelpers({
    getterType: `StudentEnrollDetail/getField`,
    mutationType: `StudentEnrollDetail/updateField`,
  });
  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });
  const {
    mapFields: mapClassAssignmentFields,
  } = createHelpers({
    getterType: `ClassAssignment/getField`,
    mutationType: `ClassAssignment/updateField`,
  });

  export default {
    props:{
      classSectionId: {
        type: String,
        require: true,
      }
    },
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
      CardSubjectInfo,
    },
    data() {
      return {
        table:  {
          header: [
            // {title: 'live-class-schedule.no', id: 'no'},
            {title: 'student-enroll.student-code', id: 'studentCode'},
            {title: 'student-enroll.student-name', id: 'studentName'},
            {title: 'student-stats.assignment', id: 'studentAssignment'},
            {title: 'student-stats.total-learn-time', id: 'totalLearnTime'},
            {title: 'student-stats.total-vdo-length', id: 'totalVdoLength'},
            {title: 'student-stats.percent', id: 'learnPercent'},
          ]
        },
        expandTable:{
          header: [
            {title: 'student-stats.unit-seq', id: 'unitSeq'},
            {title: 'student-stats.total-learn-time', id: 'totalLearnTime'},
            {title: 'student-stats.total-vdo-length', id: 'totalVdoLength'},
            {title: 'student-stats.percent', id: 'learnPercent'},
            {title: 'student-stats.pre-test-score', id: 'pretestScore'},
            {title: 'student-stats.post-test-score', id: 'posttestScore'},
          ]
        },
        tableConfig: tableConfig,

        isProcessing: true,

        //manual data
        courseOutline: null,
        classAssignments: [],
        studentEnrollDetails: [],

        moment: moment,
        dateTimeFormat: dateTimeFormat,
        getAvatarUrl,
        formatSecondToHHMMSS,

        haveValueChange: false,

        selectedRow: {},
      }
    },
    computed: {
      ...mapStudentEnrollDetailFields({studentEnrollDetailProcessing: 'processing',}),
      ...mapCourseOutlineFields({courseOutlineProcessing: 'processing',}),
      ...mapClassAssignmentFields({classAssignmentProcessing: 'processing',}),
      isValueChanged(){
        return this.haveValueChange;
      },
    },
    watch: {
      courseOutlineProcessing(data) {
        this.isProcessing = data;
      },
      studentEnrollDetailProcessing(data) {
        this.isProcessing = data;
      },
      classAssignmentProcessing(data) {
        this.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapStudentEnrollDetailActions({
        getStudentEnrollDetailsStat: 'getStudentEnrollDetailsStat',
      }),
      ...mapCourseOutlineActions({
        getCourseOutlinesByClassSection: 'getCourseOutlinesByClassSection',
      }),
      ...mapClassAssignmentActions({
        getClassAssignmentsByFilter: 'getClassAssignmentsByFilter',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onBackClick(){
        this.$router.push({
          name: 'home',
        })
      },
      handlerRowSelected(row){
        this.selectedRow = row;
      },
      async handlerExportExcelClick(){
        const rsc = JSON.parse(localStorage.getItem("rsc"));
        let entity, stage
        if (rsc) {
          entity = rsc.e_code;
          stage = rsc.r_stage;
        }
        let url = APIServerPrisma2
          + '/api/export_excel_student_stat'
          + '/' + this.$route.params.classSectionId
          + '/' + entity
          + '/' + stage;
        window.open(url, '_self');
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        let payload = {
          classAssignmentFilterInput:{
            classSectionId: this.$route.params.classSectionId,
          }
        };
        let result = await this.getClassAssignmentsByFilter(payload);

        if(result){
          this.classAssignments = result;
        }

        let courseOutlinePayload = {
          id: this.$route.params.classSectionId,
        }
        let resultCourseOutline = await this.getCourseOutlinesByClassSection(courseOutlinePayload);

        if(resultCourseOutline){
          this.courseOutline = resultCourseOutline;
        }
      },
      async loadData() {
        let payload = {
          studentEnrollDetailFilterInput:{
            classSectionId: this.$route.params.classSectionId,
            // isDrop: false,
          }
        };
        let result = await this.getStudentEnrollDetailsStat(payload);

        if(result){
          this.studentEnrollDetails = result;
        }
      },
    },
    async beforeMount() {
      await this.initData();
      await this.loadData();
    }
  }
</script>

<style scoped>

</style>

